import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { PersonService } from 'src/app/services/person.service';

@Component({
  selector: 'app-activate-user-modal',
  standalone: false,
  templateUrl: './activate-user-modal.component.html',
  styleUrl: './activate-user-modal.component.scss'
})
export class ActivateUserModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Input() 
  personId!: string;

  @Output() onCancel = new EventEmitter();
  @Output() onActivate = new EventEmitter();

  cancelButtonOptions: any;
  activateButtonOptions: any;

  constructor(
    private personService: PersonService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ){
    
  }

  ngOnInit() {
    this.cancelButtonOptions = {
      stylingMode: 'contained',
      type: 'danger',
      text: this.translateService.instant('COMMON.CANCEL'),
      onClick: () => this.cancel()
    };

    this.activateButtonOptions = {
      stylingMode: 'contained',
      type: 'normal',
      text: this.translateService.instant('COMMON.ACTIVATE'),
      onClick: () => this.activate()
    };
  }

  activate() {
    this.loadingService.load(
      this.personService.activePerson(this.personId)
    ).subscribe(() => {
      this.toastrService.success(
        this.translateService.instant('ACTIVATE-USER.ACTIVATED-USER-SUCCESSFULLY')
      );

      this.onActivate.emit();
      this.close();
    });
  }
   
  cancel(){
    this.onCancel.emit();
    this.close();
  }

  private close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
